import { Group, Table, Text, UnstyledButton } from '@mantine/core';
import { IconChevronDown, IconChevronUp } from '@tabler/icons-react';
import type { ReactNode } from 'react';

import { type Column, hasValues, type Row, type Sort } from './tableData';

/** A column heading: the label sorts, and the filter sits beside it so one click cannot mean both.
 * A column holding no values — a button, or a metric nobody reported — only labels itself. */
export function HeaderCell({
  column,
  rows,
  sort,
  onSort,
  filter,
}: {
  column: Column;
  rows: Row[];
  sort: Sort | null;
  onSort: () => void;
  filter: ReactNode;
}) {
  const active = sort?.key === column.key;
  const Chevron = (sort?.descending ?? true) ? IconChevronDown : IconChevronUp;

  return (
    <Table.Th ta={column.numeric ? 'right' : 'left'}>
      <Group gap={4} wrap="nowrap" justify={column.numeric ? 'flex-end' : 'flex-start'}>
        {hasValues(rows, column.key) ? (
          <UnstyledButton onClick={onSort} aria-label={`Sort by ${column.label}`}>
            <Group gap={2} wrap="nowrap">
              <Text size="xs" fw={active ? 700 : 600}>
                {column.label}
              </Text>
              {active && <Chevron size={12} />}
            </Group>
          </UnstyledButton>
        ) : (
          <Text size="xs" fw={600}>
            {column.label}
          </Text>
        )}
        {filter}
      </Group>
    </Table.Th>
  );
}
